module.exports = __webpack_public_path__ + "img/logo-pix.3aba2009.svg";